function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import { first, isArray, tail } from 'lodash';
import Modal from 'react-modal';
import ReactCrop from 'react-image-crop';

//import './styles/image-crop.scss';

export var ImageCrop = function (_React$Component) {
  _inherits(ImageCrop, _React$Component);

  function ImageCrop() {
    var _temp, _this, _ret;

    _classCallCheck(this, ImageCrop);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      uncroppedImages: [],
      croppedImages: [],
      defaultCrop: [],
      crop: [{
        width: 420,
        height: 420,
        aspect: 1 / 1
      }],
      messages: []
    }, _this.updateAndCallbacks = function (canvas, crop) {
      var newCrop = void 0;
      var messages = _this.state.messages;
      var croppedImages = _this.state.croppedImages;
      var uncroppedImages = _this.state.uncroppedImages;

      messages.shift();
      uncroppedImages.shift();
      croppedImages.unshift(canvas.toDataURL('image/jpeg'));
      isArray(_this.state.crop) ? newCrop = tail(_this.state.crop) : newCrop = crop;

      _this.setState({
        messages: messages,
        crop: newCrop,
        croppedImages: croppedImages,
        uncroppedImages: uncroppedImages
      });

      if (uncroppedImages.length < 1) {
        _this.props.stateCallback ? _this.props.stateCallback(croppedImages) : _this.props._plan.setPhotos(croppedImages);

        if (_this.props.persist) {
          _this.props.persistCallback ? _this.props.persistCallback(croppedImages) : _this.props._customer.updateImages();
        }
      }
    }, _this.closeModal = function () {
      _this.setState({
        uncroppedImages: [],
        croppedImages: [],
        messages: [],
        crop: _this.state.defaultCrop
      });

      if (_this.props.close) _this.props.close();
    }, _this.onCropComplete = function (crop) {
      var newCrop = void 0;
      isArray(_this.state.crop) ? newCrop = [crop].concat(tail(_this.state.crop)) : newCrop = crop;
      _this.setState({ crop: newCrop });
    }, _this.cropAfterLoad = function () {
      var crop = void 0;
      var realImage = new Image();
      realImage.src = first(_this.state.uncroppedImages);

      isArray(_this.state.crop) ? crop = first(_this.state.crop) : crop = _this.state.crop;

      var imageWidth = realImage.naturalWidth;
      var imageHeight = realImage.naturalHeight;

      var cropX = crop.x / 100 * imageWidth;
      var cropY = crop.y / 100 * imageHeight;

      var cropWidth = crop.width / 100 * imageWidth;
      var cropHeight = crop.height / 100 * imageHeight;

      var canvas = document.createElement('canvas');
      canvas.width = cropWidth;
      canvas.height = cropHeight;
      var ctx = canvas.getContext('2d');

      ctx.drawImage(realImage, cropX, cropY, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);
      _this.updateAndCallbacks(canvas, crop);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ImageCrop.prototype.componentDidMount = function componentDidMount() {
    if (this.props.crop) {
      this.setState({ crop: this.props.crop });
    }

    this.setState({ defaultCrop: this.props.crop ? this.props.crop : this.state.crop });

    if (this.props.messages) {
      this.setState({ messages: this.props.messages });
    }
  };

  ImageCrop.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    this.setState({
      uncroppedImages: nextProps.uncroppedImages,
      crop: nextProps.crop || this.state.crop,
      messages: nextProps.messages || []
    });

    if (nextProps.uncroppedImages.length < 1) this.setState({ croppedImages: [] });
  };

  ImageCrop.prototype.render = function render() {
    var _this2 = this;

    return React.createElement(
      Modal,
      {
        isOpen: this.state.uncroppedImages.length > 0,
        closeTimeoutMS: 150,
        className: 'modal-dialog',
        style: {
          overlay: {
            zIndex: 9999,
            backgroundColor: 'rgba(12, 10, 10, 0.75)'
          }
        },
        contentLabel: 'Image Cropper' },
      React.createElement(
        'div',
        { className: 'modal-content ignore-react-onclickoutside' },
        React.createElement(
          'div',
          null,
          React.createElement(
            'button',
            { type: 'button', className: 'close', onMouseDown: this.closeModal },
            React.createElement(
              'span',
              { 'aria-hidden': 'true' },
              '\xD7'
            ),
            React.createElement(
              'span',
              { className: 'sr-only' },
              'Close'
            )
          )
        ),
        React.createElement(
          'div',
          { className: 'modal-body' },
          React.createElement(
            'h3',
            null,
            'Image Crop'
          ),
          React.createElement(
            'h4',
            null,
            'Cropping image ',
            this.state.croppedImages.length + 1,
            ' of ',
            this.state.uncroppedImages.length + this.state.croppedImages.length
          ),
          this.state.messages.length > 0 && React.createElement(
            'p',
            null,
            first(this.state.messages)
          ),
          this.state.uncroppedImages.length > 0 && React.createElement(ReactCrop, {
            src: first(this.state.uncroppedImages),
            crop: first(this.state.crop),
            onImageLoaded: function onImageLoaded(crop) {
              return _this2.onCropComplete(crop);
            },
            onAspectRatioChange: function onAspectRatioChange(crop) {
              return _this2.onCropComplete(crop);
            },
            onComplete: function onComplete(crop) {
              return _this2.onCropComplete(crop);
            } }),
          React.createElement(
            'button',
            { className: 'orange-primary-button pull-right ml-2', onClick: this.cropAfterLoad },
            'Crop'
          ),
          React.createElement(
            'button',
            { className: 'grey-button pull-right', onClick: this.closeModal },
            'Cancel'
          )
        )
      )
    );
  };

  return ImageCrop;
}(React.Component);

ImageCrop.defaultProps = {
  persist: false
};

ImageCrop.propTypes = process.env.NODE_ENV !== "production" ? {
  close: PropTypes.func,
  stateCallback: PropTypes.func,
  persistCallback: PropTypes.func,
  uncroppedImages: PropTypes.array.isRequired,
  persist: PropTypes.bool,
  crop: PropTypes.array,
  messages: PropTypes.array
} : {};


//////////////////
// WEBPACK FOOTER
// ../ui-components/es/ImageCrop.js
// module id = 638
// module chunks = 4